import styled from "vue-styled-components";

export const Content = styled.div`
    padding-bottom: 5rem;
    width: 100%;
    max-width: 700px;

    overflow: hidden;

    .questions-categories {
        display: flex;
    }

    .quiz-progress {
        display: flex;
        justify-content: center;
        gap: 0.8rem;
        margin-top: 1rem;

        button {
            display: flex;
            align-items: center;
            padding: 1rem 0;
            cursor: pointer;
            outline: none;
            border: none;
            background: transparent;

            span {
                display: inline-block;
                height: 0.3rem;
                width: 2.5rem;
                border-radius: 0.25rem;
                background: #ddd;
            }

            &.active span {
                background: ${props => props.theme?.primary_color};
            }
        }
    }
`;
